<template>
  <!-- <div id="app" ref="app" class="flex-col con-app"> -->
  <div id="app" ref="app" class="flex-col con-app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view class="f1" v-if="!$route.meta.keepAlive" />
    <!--底部导航的占位高度 v-show="showAppBar" -->
    <div v-if="navbar" v-show="showAppBar" class="placeholder-bar-nav-app"></div>
    <AppNavBar v-if="navbar" v-show="showAppBar" class="bar-nav-app iphoneX" />
  </div>
</template>

<script>
import AppNavBar from "@/components/AppNavBar";
import storage from "@/utils/storage";
import { userInfo, deLogin } from "@/apis/login";
export default {
  data() {
    return {
      navbar: true
    };
  },
  name: "App",
  components: { AppNavBar },
  computed: {
    showAppBar() {
      const showList = [];
      this.$router.options.routes.map(item => {
        if (!item.falg) {
          showList.push(item.name);
        }
      });
      return showList.includes(this.$route.name);
    },
  },
  methods: {
  },
  watch: {
    $route: {
      handler(newVal) {
        //  let navShow=this.$route.query.navbar
        //  let userPhone=this.$route.query.userPhone
        if (newVal.name == "login" || newVal.name == "wxbind") {
          this.$refs.app.style = "height: 100%;";
          return;
        }
        // if (newVal.name != "home" &&newVal.name != "mine" &&newVal.name != "login" &&newVal.name != "privacy" &&newVal.name != "collection") {
        //   if(navShow=='false'){
        //     this.$refs.app.style = "";
        //     this.navbar= false 
        //     if (userPhone!="null"||newVal.name== "policy") {
        //      this.otherLogin(userPhone)                       
        //     }
        //   }else if(newVal.name != "parkNotice" &&newVal.name != "policyNotice" &&newVal.name != "enterpriseFilling"){
        //     this.$refs.app.style = "padding-bottom: 60px;"; 
        //   }
        // } else {
        //   this.$refs.app.style = "";     
        // }
      },
      deep: true
    }
  },
  created() {
    // 将 vue 实例传递给 axios，在拦截器里面可能会用到
    this.apis.public.getVueInstance(this);
  }
};
</script>

<style>
html {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>

<style lang="less" scoped>
#app {
  // padding-bottom: 80px;
  // background: #f8f9fd;
  height: 100%;
}

.con-app {

  // min-height: 100vh;
  .bar-nav-app {
    width: 100%;
    bottom: 0;
    z-index: 1000;
    position: fixed;
  }

  .placeholder-bar-nav-app {
    // height: 96px;
    // background: pink;
  }
}
</style>
